import { render, staticRenderFns } from "./Penta5_Regular.vue?vue&type=template&id=71c6e1a8&"
import script from "./Penta5_Regular.vue?vue&type=script&lang=js&"
export * from "./Penta5_Regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports